import React from "react";
import Img from "../../Assets/Images/Birth_Image1.jpeg";
import "./sponsors.css";
import SponserBlock from "../../Components/SponserBlock/SponserBlock";
import Sponsors from "../../Components/Home/Sponsers/Sponsers";
import StaticPageHeaders from "../../Components/StaticPageHeaders";
import s_1 from "../../Assets/Images/Sponsers/sponser_1.png";
import s_2 from "../../Assets/Images/Sponsers/sponser_2.png";
import s_3 from "../../Assets/Images/Sponsers/sponser_3.png";
import SEO from "../../Components/SEO";

const SuccessStoriesBlock = [
  {
    image: s_1,
    name: "MIKE'S DINER",
    description:
      "Visit both of Mike Mouddatsos Jr’s Diners. The son of diner mogul Mike Moudatsos has renovated both diners and revamped their menus to elevate both of them into jewels of Staten Island Diners.",
    orders: "right",
  },
  {
    image: s_2,
    name: "THE KETTLE BLACK",
    description:
      "Kettle Black is a restaurant and bar on Staten Island & Brooklyn. Kettle Black boasts “The Best Wings, Burgers and Beers”.",
    orders: "left",
  },
  {
    image: s_3,
    name: "DENINO'S PIZZERIA",
    description:
      "Denino’s Pizzeria is a landmark in New York, with award winning, thin-crust pizza. Since 1951, Denino’s Pizzeria and Tavern has been renowned for their pizza pie and Italian dinner platters, which are always prepared fresh. They use their family’s recipes for Chicken Parmigiana, Meatballs and Sausage and over the years they’ve added their own version of tavern favorites like Wings, Scungilli and Hero Sandwiches.",
    orders: "right",
  },
];

const SponsorsPage = () => {
  return (
    <>
      <SEO
        title="Sponsors - Shootin School Basketball"
        description=""
        url="https://shootinschool.com/sponsors/"
      />
      <StaticPageHeaders title="Sponsors" />

      <div className="sponsors-container">
        <div className="sponsors-sss-layout">
          <div className="sss-grid">
            {SuccessStoriesBlock.map((successstory, i) => (
              <SponserBlock
                key={i}
                image={successstory.image}
                name={successstory.name}
                description={successstory.description}
                order={successstory.orders}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="about-sponsors sss-sp bg-custom brightness">
        <Sponsors brValue={1} />
      </div>
    </>
  );
};
export default SponsorsPage;
